import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './Welcome.module.css';
import WelcomeNavBar from './WelcomeNavBar';
import sliderDec from '../../assets/img/landing/slider-dec.webp';
import ServicesSection from './Servicessection';
import AboutSection from './AboutSection';
import BookletSection from './BookletSection';
import FooterSection from './Footersection';

interface HandPhoneProps {
  classNames: {
    heroIllustration: string;
    chatBubble: string;
    chatBubbleRight: string;
    chatBubbleLeft: string;
    bubbleLine: string;
    bubbleLineShort: string;
    bubbleLineShorter: string;
    paperPlane: string;
    plane1: string;
    plane2: string;
    phoneHandWrapper: string;
    phoneWrapper: string;
    handShape: string;
    phoneSvg: string;
  };
}

const HandPhone: React.FC<HandPhoneProps> = ({ classNames }) => (
  <div className={classNames.heroIllustration}>
    <img
      src={sliderDec}
      alt="Welcome illustration"
      className={styles.heroImage}
      width={960}
      height={640}
      decoding="async"
    />
  </div>
);

const Welcome: React.FC = () => {
  const navigate = useNavigate();
  const { hash, pathname } = useLocation();
  const [showSecondParagraph, setShowSecondParagraph] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowSecondParagraph(true), 4500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (pathname !== '/igisekuruza' || !hash) return;
    const id = hash.replace(/^#/, '');
    const el = document.getElementById(id);
    if (el) {
      const t = window.setTimeout(() => {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 80);
      return () => window.clearTimeout(t);
    }
  }, [hash, pathname]);
  const handPhoneClasses = {
    heroIllustration: styles.heroIllustration,
    chatBubble: styles.chatBubble,
    chatBubbleRight: styles.chatBubbleRight,
    chatBubbleLeft: styles.chatBubbleLeft,
    bubbleLine: styles.bubbleLine,
    bubbleLineShort: styles.bubbleLineShort,
    bubbleLineShorter: styles.bubbleLineShorter,
    paperPlane: styles.paperPlane,
    plane1: styles.plane1,
    plane2: styles.plane2,
    phoneHandWrapper: styles.phoneHandWrapper,
    phoneWrapper: styles.phoneWrapper,
    handShape: styles.handShape,
    phoneSvg: styles.phoneSvg,
  };

  return (
    <div className={styles.root}>
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&family=Poppins:wght@400;500;600&display=swap"
      />

      <WelcomeNavBar />

      <main className={styles.mainContent}>
      <section id="home" className={styles.hero}>
        <div className={styles.heroBg}>
          <div className={styles.blobMain} />
          <div className={styles.blobWave} />
          <div className={styles.blobCircle} />
          <div className={`${styles.ghostSq} ${styles.ghostSq1}`} />
          <div className={`${styles.ghostSq} ${styles.ghostSq2}`} />
          <div className={`${styles.ghostSq} ${styles.ghostSq3}`} />
          <div className={`${styles.ghostSq} ${styles.ghostSq4}`} />
        </div>

        <div className={styles.heroContent}>
          <div className={styles.heroText}>
            <h1 className={styles.heroTitle}>
            Trace Your Roots Build Your Legacy
            </h1>
            {!showSecondParagraph ? (
              <p className={styles.heroDesc}>
                In Rwandan culture, IBISEKURUZA is the proud tradition of remembering and reciting one's lineage, often up to seven generations, as a way to honor ancestry, maintain social cohesion, and prevent intermarriage within close kin. It embodies identity, respect, and the continuity of family values.
              </p>
            ) : (
              <p className={`${styles.heroDesc} ${styles.heroDescSecondary}`}>
                Through iGiTREE, this timeless practice is being revived and digitized, ensuring that the spirit of IBISEKURUZA lives on in the modern, tech-driven generation. By exploring their roots, children learn to honor the past and build pride in their identity.
              </p>
            )}
            <div className={styles.heroCtas}>
              <button type="button" onClick={() => navigate('/about')} className={`${styles.btnCta} ${styles.btnCtaPrimary}`}>
                Get Started
                {/* <svg width="16" height="16" viewBox="0 0 24 24" fill="white" aria-hidden>
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                </svg> */}
              </button>
              <button
                type="button"
                className={`${styles.btnCta} ${styles.btnCtaSecondary}`}
                onClick={() => navigate('/contact')}
              >
                Contact Us
                {/* <svg width="18" height="18" viewBox="0 0 24 24" fill="white" aria-hidden>
                  <path d="M3.18 23.76c.31.17.67.19 1 .06l12.35-6.17-2.89-2.89-10.46 9zM.1 1.5C.04 1.74 0 2 0 2.27v19.46c0 .27.04.53.1.77l10.58-10.59L.1 1.5zM14.83 12l2.51 2.51 2.93-1.46c.84-.42.84-1.1 0-1.52l-2.93-1.46L14.83 12zM4.17.17L14.83 11l2.89-2.89L5.17.11C4.83-.04 4.47-.02 4.17.17z" />
                </svg> */}
              </button>
            </div>
          </div>

          <HandPhone classNames={handPhoneClasses} />
          {/* fixed */}
        </div>
      </section>
      </main>
      <ServicesSection />
      <AboutSection />
      <BookletSection />
      <FooterSection />
    </div>
  );
};

export default Welcome;
